import { useState, useEffect } from "react";

const SEVERITY = {
  info:    { bg: "#1a6fcf", text: "#fff",     label: "Info" },
  warning: { bg: "#e6a817", text: "#1a1a1a",  label: "Warning" },
  alert:   { bg: "#c0392b", text: "#fff",     label: "Alert" },
};

function isActive(a) {
  const today = new Date().toISOString().slice(0, 10);
  return a.start_date.slice(0, 10) <= today && today <= a.end_date.slice(0, 10);
}

export default function AlertBanner({ top = 60 }) {
  const [alerts, setAlerts] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("dismissed_alerts") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    fetch("/api/alerts")
      .then(r => r.json())
      .then(d => setAlerts((d.rows || []).filter(isActive)))
      .catch(() => {});
  }, []);

  const visible = alerts.filter(a => !dismissed.includes(a.id));
  if (!visible.length) return null;

  function dismiss(id) {
    const next = [...dismissed, id];
    setDismissed(next);
    try { sessionStorage.setItem("dismissed_alerts", JSON.stringify(next)); } catch {}
  }

  return (
    <div
      role="region"
      aria-label="System alerts"
      style={{
        position: "fixed",
        top: `${top}px`,
        left: 0,
        right: 0,
        zIndex: 1029,
      }}
    >
      {visible.map(a => {
        const s = SEVERITY[a.severity] || SEVERITY.info;
        return (
          <div
            key={a.id}
            role="alert"
            style={{
              backgroundColor: s.bg,
              color: s.text,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "9px 16px",
              fontSize: "0.875rem",
              lineHeight: 1.4,
              gap: "12px",
              borderBottom: "1px solid rgba(0,0,0,0.15)",
            }}
          >
            <div style={{ display: "flex", alignItems: "baseline", gap: "8px", flexWrap: "wrap", flex: 1 }}>
              <strong style={{ textTransform: "uppercase", fontSize: "0.7rem", letterSpacing: "0.06em", flexShrink: 0, opacity: 0.85 }}>
                {s.label}
              </strong>
              <span>
                <strong>{a.name}</strong>
                {a.description ? ` — ${a.description}` : ""}
              </span>
            </div>
            <button
              type="button"
              aria-label="Dismiss"
              onClick={() => dismiss(a.id)}
              style={{
                background: "none",
                border: "none",
                color: s.text,
                cursor: "pointer",
                fontSize: "1.25rem",
                lineHeight: 1,
                padding: "0 2px",
                flexShrink: 0,
                opacity: 0.7,
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
